import init from '../../common/base/init';
import { hasClosest } from 'js-utils/src/selector';
import { onCssAnimationEnd } from 'js-utils/src/animation';


init(() => {
  const purchaseNotice = document.querySelector('.purchase-notice');
  if(!purchaseNotice) return;

  // Share menu
  const purchaseNoticeShareButton = purchaseNotice.querySelector('.purchase-notice__box__share__button');
  if(purchaseNoticeShareButton) {
    const shareButton = document.querySelector('.post-share__inner');
    purchaseNoticeShareButton.addEventListener('click', (e) => {
      e.preventDefault();

      purchaseNotice.classList.add('--hide');
      onCssAnimationEnd(purchaseNotice, () => purchaseNotice.parentNode.removeChild(purchaseNotice));

      shareButton.classList.add('do-show-opts');
      shareButton.scrollIntoView();
    });
  }


  // close on outside click
  if(purchaseNotice.classList.contains('js--purchase-notice-close-outside-click')) {
    const contentEl = purchaseNotice.querySelector('.js--purchase-notice-content');
    if(contentEl) {
      purchaseNotice.addEventListener('click', (e) => {
        if(!hasClosest(e.target, contentEl)) {
          purchaseNotice.classList.add('--hide');
          onCssAnimationEnd(purchaseNotice, () => purchaseNotice.parentNode.removeChild(purchaseNotice));
        }
      });
    }
  }

  // close on button click
  const closeNotice = purchaseNotice.querySelector('.purchase-notice__box__close');

  closeNotice.addEventListener('click', (e) => {
    e.preventDefault();

    purchaseNotice.classList.add('--hide');
    onCssAnimationEnd(purchaseNotice, () => purchaseNotice.parentNode.removeChild(purchaseNotice));
  });
});
